export { default as useEdDeleteQuery } from './useEdDeleteQuery';
